import { configureStore } from '@reduxjs/toolkit';
import { loadingBarReducer } from 'react-redux-loading-bar';
import { combineReducers } from 'redux';
import createSagaMiddleware from 'redux-saga';
import globalReducer from '../../containers/App/reducer';

// Detect if Saga monitor extension is available
const isDev = process.env.NODE_ENV !== 'production';
const hasWindow = typeof window === 'object';

let sagaMonitor = undefined;

if (isDev && hasWindow && window.__SAGA_MONITOR_EXTENSION__) {
  sagaMonitor = window.__SAGA_MONITOR_EXTENSION__;
}

// Create the saga middleware with optional monitor
const sagaMiddleware = createSagaMiddleware({ sagaMonitor });

// Optional middleware array
const middleware = [sagaMiddleware];

// Add redux-logger in development
if (isDev) {
  const { createLogger } = require('redux-logger');
  const logger = createLogger({ collapsed: true, duration: true });
  middleware.push(logger);
}

const createReducer = (injectedReducers = {}) =>
  combineReducers({
    loadingBar: loadingBarReducer,
    global: globalReducer,
    ...injectedReducers,
  });

// Create the store
const store = configureStore({
  reducer: createReducer(), // Combined reducer from a custom function
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      thunk: true, // Keep this ON to support createAsyncThunk
      serializableCheck: false,
    }).concat(middleware),
  devTools: isDev,
  preloadedState: {}, // Optional: use if needed
});

export default store;

// Run the root saga
store.runSaga = sagaMiddleware.run;

// Enable reducer/saga injection
store.injectedReducers = {}; // Reducer registry
store.injectedSagas = {}; // Saga registry

export function injectReducer(key, reducer) {
  if (!store.injectedReducers[key]) {
    store.injectedReducers[key] = reducer;
    store.replaceReducer(createReducer(store.injectedReducers));
  }
}

// Make reducers hot reloadable
// TODO: Re-enable hot reloading if needed and Remove this after full migration to RTK
// if (module.hot) {
//   module.hot.accept(() => {
//     store.replaceReducer(createReducer(store.injectedReducers));
//   });
// }
